/* eslint-disable */
import React from 'react';

function DetailTabCont4() {
  return (
    <>
      <section className="box cont_box">
        <div className="cont_tit">공지 내용</div>
        <div className="com_board_box">
          1) 평가 기준 <br />
          - 캠페인 기간내 <br />
          (수업수 + 인센티브 + 기여도) - (손실 + c/s) 합산 점수 <br />
          &lt;중단0&gt;과 &lt;인계0&gt;은 집계에서 제외함 <br />
          &lt;중단/인계 1사유가 1건 발생시에만 만회가능 &gt; <br /> <br />
          2) 캠페인 기간 內 누적수업 90회 이상 <br />
          수업한 교사를 1~3위로 선정
          <div className="com_btn_wrap center btn_fixed right">
            <button className="com_btn black xs btn_down_orange">다운로드</button>
          </div>
        </div>
      </section>
      <section className="box cont_box">
        <div className="cont_tit">그룹</div>
        <div className="com_board_box">
          <ul className="group_list">
            <li className="group">
              <div className="com_info">
                <p className="name">국어</p>
              </div>
              <div className="board_item_table_round">
                <table className="com_board_list">
                  <colgroup>
                    <col width="110" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="th_left">포인트 점수</th>
                      <td className="td_left">480P 이상</td>
                    </tr>
                    <tr>
                      <th className="th_left">목표 타임</th>
                      <td className="td_left">60타임</td>
                    </tr>
                    <tr>
                      <th className="th_left">대표교사</th>
                      <td className="td_left">김교사103</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
            <li className="group">
              <div className="com_info">
                <p className="name">수학</p>
              </div>
              <div className="board_item_table_round">
                <table className="com_board_list">
                  <colgroup>
                    <col width="110" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="th_left">포인트 점수</th>
                      <td className="td_left">480P 이상</td>
                    </tr>
                    <tr>
                      <th className="th_left">목표 타임</th>
                      <td className="td_left">60타임</td>
                    </tr>
                    <tr>
                      <th className="th_left">대표교사</th>
                      <td className="td_left">김교사103</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <section className="box cont_box">
        <div className="cont_tit">결과</div>
        <div className="com_board_box">
          <ul className="group_list">
            <li className="group">
              <div className="com_info">
                <p className="name">국어 (미달성)</p>
              </div>
              <div className="board_item_table_round">
                <table className="com_board_list">
                  <colgroup>
                    <col width="110" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="th_left">목표 포인트</th>
                      <td className="td_left">480P 이상</td>
                    </tr>
                    <tr>
                      <th className="th_left">목표 타임</th>
                      <td className="td_left">60타임</td>
                    </tr>
                    <tr>
                      <th className="th_left">대표 교사</th>
                      <td className="td_left">김교사103</td>
                    </tr>
                    <tr>
                      <th className="th_left">달성 포인트</th>
                      <td className="td_left">432</td>
                    </tr>
                    <tr>
                      <th className="th_left">달성률</th>
                      <td className="td_left">90%</td>
                    </tr>
                    <tr>
                      <th className="th_left">인원수</th>
                      <td className="td_left">80</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
            <li className="group">
              <div className="com_info">
                <p className="name">수학 (달성)</p>
              </div>
              <div className="board_item_table_round">
                <table className="com_board_list">
                  <colgroup>
                    <col width="110" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="th_left">목표 포인트</th>
                      <td className="td_left">480P 이상</td>
                    </tr>
                    <tr>
                      <th className="th_left">목표 타임</th>
                      <td className="td_left">60타임</td>
                    </tr>
                    <tr>
                      <th className="th_left">대표 교사</th>
                      <td className="td_left">김교사103</td>
                    </tr>
                    <tr>
                      <th className="th_left">달성 포인트</th>
                      <td className="td_left">432</td>
                    </tr>
                    <tr>
                      <th className="th_left">달성률</th>
                      <td className="td_left">90%</td>
                    </tr>
                    <tr>
                      <th className="th_left">인원수</th>
                      <td className="td_left">80</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
}

export default DetailTabCont4;
